export default function scrollToErrorViewById(errors){
    const fieldErrorNames = Object.keys(errors)[0];
    if (fieldErrorNames.length <= 0) return;
    const element = document.getElementById(fieldErrorNames);
    if (!element) return;

    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
};
